import { HttpStatusCode } from "axios";

import { UpdateUserState } from "../../contexts/userContext";

import { getMemberInfo, updateAppVersion } from "../../services/memberServices";
import { logout } from "../../services/authServices";

type Props = {
  updateField: (params: UpdateUserState) => Promise<void>;
  pushCall: (id: string) => void;
  appVersion?: string;
  deviceType?: string;
  open?: (message: string) => void;
};

export default function userMemberInfo({
  updateField,
  pushCall,
  appVersion,
  deviceType,
  open,
}: Props): {
  loadingUserData: () => void;
} {
  let res: any;

  const loadingUserData = async () => {
    try {
      res = await getMemberInfo();
      if (res.status === HttpStatusCode.Ok) {
        await updateField({ ...res.data });
      } else {
        console.log("useMemberInfo getMemberInfo Failed" + res);
      }
    } catch (e: any) {
      if (e?.response?.status === HttpStatusCode.Unauthorized) {
        logout();
      } else if (e?.response?.data?.message) {
        open?.(e?.response?.data?.message.replace(". ", ".\n"));
      } else {
        open?.("앱 버전 업데이트에 실패하였습니다.");
      }
    }

    try {
      await pushCall(res.data.memberId.toString());
      if (
        appVersion &&
        appVersion.length > 0 &&
        deviceType &&
        deviceType.length > 0
      ) {
        await updateAppVersion({ appVersion, deviceType });
      } else {
        console.log("appVersion or deviceType is empty");
      }
    } catch (e: any) {
      if (e?.response?.status === HttpStatusCode.Unauthorized) {
        logout();
      } else if (e?.response?.data?.message) {
        open?.(e?.response?.data?.message.replace(". ", ".\n"));
      } else {
        open?.("앱 버전 업데이트에 실패하였습니다.");
      }
    }
    await updateField({ isLoading: false });
  };

  return { loadingUserData };
}
